const prefix = 'Rainmakers/ToolboxRequisitions/';

export const DUPLICATE_REQUISITION = `${prefix}DUPLICATE_REQUISITION`;
